import React from 'react';
import { MessageCircle } from 'lucide-react';
export function FooterCTA() {
  return <section className="py-32 px-4 sm:px-6 lg:px-8 bg-[#00E5FF] relative overflow-hidden" data-id="element-22">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10 mix-blend-overlay" data-id="element-23" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-24">
        <h2 className="text-5xl md:text-7xl font-black text-black tracking-tighter mb-8" data-id="element-25">
          ¿LISTO PARA ESCALAR?
        </h2>
        <p className="text-xl md:text-2xl text-black/80 font-medium mb-12" data-id="element-26">
          Únete a la fábrica. Comunicación 100% por chat. Ejecución inmediata.
        </p>

        <a href="#pricing" onClick={e => {
        e.preventDefault();
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="inline-flex items-center justify-center gap-3 px-10 py-5 text-xl font-bold text-white bg-black rounded-full hover:bg-gray-900 transition-transform hover:scale-105 shadow-2xl" data-id="element-27">
          <MessageCircle className="w-6 h-6" data-id="element-28" />
          Iniciar mi Lote
        </a>
      </div>
    </section>;
}